import { render, staticRenderFns } from "./listClinicInvoice.vue?vue&type=template&id=c515bc96&scoped=true&"
import script from "./listClinicInvoice.vue?vue&type=script&lang=js&"
export * from "./listClinicInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c515bc96",
  null
  
)

export default component.exports